import { createFileRoute } from "@tanstack/react-router";
import { useAudiolab } from "@/components/providers/AudiolabProvider/hooks";
import AudiolabDashboard from "@/components/audiolab/AudiolabDashboard";
import { useTracksControllerTracksList } from "@/lib/lutely-api/gen/tracks/tracks";

export const Route = createFileRoute("/audiolab/")({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "Audiolab | Lutely",
      },
      {
        name: "description",
        content:
          "Create, edit, and manage your music tracks, beats, releases, and soundkits with Lutely's Audiolab, designed for talented creators around the world.",
      },
    ],
  }),
});

function RouteComponent() {
  const { selectedCreator, viewAllArtists } = useAudiolab();
  const creatorId = selectedCreator?.creatorId;

  // Check if creator has any tracks
  const { isLoading } = useTracksControllerTracksList(
    viewAllArtists
      ? { ownedOnly: true, pageSize: 1 }
      : { creatorId, pageSize: 1 },
    { query: { enabled: viewAllArtists || !!creatorId } },
  );

  if ((!creatorId && !viewAllArtists) || isLoading) {
    return null;
  }

  return (
    /* No creatorId in the roster view: the library layout keys its artist
       hero off it, and a single artist's banner over the aggregate misleads */
    <AudiolabDashboard
      creatorId={viewAllArtists ? undefined : creatorId}
      allArtists={viewAllArtists}
    />
  );
}
